import React from 'react';
import { useTranslation } from 'react-i18next';
import './About.css';

function About() {
  const { t } = useTranslation();

  return (
    <section className="py-5 py-lg-6 bg-white" id="about">
      <div className="container">
        <div className="about-card rounded-3 overflow-hidden border border-secondary-subtle shadow-sm bg-light">
          <div className="row g-0">
 
            <div className="col-lg-7 p-4 p-lg-5 d-flex flex-column justify-content-center">
              <h2 className="h3 fw-semibold text-navy mb-1">{t('about.name')}</h2>
              <p className="text-muted small text-uppercase letter-spacing-wide mb-4">{t('about.title')}</p>

              <h3 className="h5 fw-semibold text-navy mb-3">{t('about.heading')}</h3>
              <p className="text-muted mb-3">{t('about.bio1')}</p>
              <p className="text-muted mb-4">{t('about.bio2')}</p>


              <dl className="row m-0 p-0 w-100 small">
                <dt className="col-sm-4 text-muted">{t('about.experience')}</dt>
                <dd className="col-sm-8 text-navy fw-medium m-0 mb-3">{t('about.experienceValue')}</dd>
                <dt className="col-sm-4 text-muted">{t('about.admissions')}</dt>
                <dd className="col-sm-8 text-navy m-0 mb-3">{t('about.admissionsValue')}</dd>
                <dt className="col-sm-4 text-muted">{t('about.focus')}</dt>
                <dd className="col-sm-8 text-navy m-0">{t('about.focusValue')}</dd>
              </dl>
            </div>
 
            <div className="col-lg-5 about-img-col order-first order-lg-last">
              <img src="/Images/marwaHawshar.jpg" alt={t('about.photoAlt')} />
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
